var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.variant === 'base')?_c('label',{class:[
    'slds-form-element__label',
    { 'slds-assistive-text': _vm.assistiveText && !_vm.label },
    _vm.className ],attrs:{"for":_vm.htmlFor}},[(_vm.required)?_c('abbr',{staticClass:"slds-required",attrs:{"title":"required"}},[_vm._v("*")]):_vm._e(),_vm._v(_vm._s(_vm.labelText))]):(_vm.variant === 'static')?_c('span',{class:['slds-form-element__label', _vm.className]},[_vm._v(_vm._s(_vm.labelText))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }